<app-header></app-header><div class="container">
  <div class="breadcrumbs mt-4">
    <div routerLink="/">Главная</div>
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M9 18L15 12L9 6" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
    <div routerLink="/tekhnicheskoe-diagnostirovanie">Техническое освидетельствование опасных производственных объектов: технических устройств, зданий и сооружений
    </div>
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M9 18L15 12L9 6" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
    <div routerLink="/tekhnicheskoe-diagnostirovanie/obsledovanie-kotlov">Техническое освидетельствование и диагностирование котлов работающих под давлением

    </div>
  </div>
  <div class="row">
    <h1 class="w-100 mt-70">Техническое освидетельствование и диагностирование котлов работающих под давлением

    </h1>
    <ul class="link-arrow">
      <li>- В Москве и регионах</li>
      <li>- Собственная лаборатория неразрушающего контроля</li>
      <li>- 20 лет опыта</li>
      <li>- Строгое соблюдение сроков</li>
    </ul>

    <p>В целях безопасного использования опасных производственных объектов, на которых применяется оборудование, работающее под избыточным давлением более 0,07 Мпа или при температуре более 115&deg;С (включая паровые, водогрейные и другие котлы) - необходимо периодически проводить их техническое освидетельствование.</p>

      <p>Эксплуатирующая организация обязана обеспечить вышеуказанную процедуру в соответствии <strong>Федеральными нормами и правилами в области промышленной безопасности &quot;Правила промышленной безопасности при использовании оборудования, работающего под избыточным давлением&quot;</strong>, утвержденными приказом Ростехнадзора от 15 декабря 2020 года № 536.</p>

    <p class="title__red" style="margin-bottom: 0;">Наши специалисты:</p>

    <ul class="marked ml-50">
      <li>Проведут диагностирование водогрейного котла, парового котла и прочего оборудования, работающего под избыточным давлением более 0,07 МПа или при температуре более 115&deg;С;</li>
      <li>Проверят котлы на соответствие дополнительным требованиям промышленной безопасности к их эксплуатации;</li>
      <li>Подготовят необходимые отчеты и заключения;</li>
      <li>Внесут специальные отметки в паспорт оборудования;</li>
      <li>Проведут экспертизу промышленной безопасности;</li>
      <li>Дадут разъяснения по каждому этапу.</li>
    </ul>

    <h3>Стоимость: от 30 000 рублей.</h3>
    <app-recall-form heading="Нет времени изучать детали? Напишите Ваш вопрос, и наши специалисты Вас проконсультируют"></app-recall-form>
    <p>Техническое освидетельствование водогрейных котлов, паровых котлов, сосудов, работающих под давлением, и пр. включает в себя:</p>

    <ul class="marked ml-50">
      <li><strong>наружный и внутренний осмотр</strong> оборудования и его компонентов;</li>
      <li><strong>осмотр металлоконструкций </strong>(при их наличии);</li>
      <li><strong>проведение гидравлических испытаний.</strong></li>
    </ul>

    <p>Техническое освидетельствование паровых котлов, водогрейных котлов и пр. оборудования, включающего<strong> наружный и внутренний осмотры производится не реже одного раза в четыре года, а гидравлическое испытание - одного раза в восемь лет.</strong></p>

    <p><strong>Техническое освидетельствование </strong>и диагностирование котлов, работающих под давлением, проводится согласно Федеральным нормам и правилам в области промышленной безопасности <strong>&quot;Правила промышленной безопасности при использовании оборудования, работающего под избыточным давлением&quot;</strong>, утвержденным приказом Ростехнадзора от 15 декабря 2020 года № 536.</p>

    <p><strong>Если Вам требуется техническое освидетельствование, диагностирование или экспертиза промышленной безопасности оборудования, работающего под избыточным давлением- опытные эксперты нашей компании проведут комплекс требуемых мероприятий и подготовят необходимые заключения. ООО &laquo;Протос Экспертиза&raquo; более 20 лет работает в области промышленной безопасности, строго соблюдая сроки оказания услуг. Стоимость рассчитывается индивидуально.</strong></p>
    <app-recall-form heading="У вас есть вопрос? Наши специалисты вас проконсультируют"></app-recall-form>
    <h2>Справочная информация:</h2>

    <p>Федеральные нормы и правила в области промышленной безопасности, <strong>утвержденные приказом Ростехнадзора от 15 декабря 2020 года № 536</strong>, распространяются на:</p>

    <ul class="marked ml-50">
      <li>паровые котлы, включая котлы-бойлеры, автономные пароперегреватели, экономайзеры, в т.ч. работающие с иными теплоносителями<a name="P0031"></a>;</li>
      <li>водогрейные и пароводогрейные котлы, в т.ч. энерготехнологические;<a name="P0033"></a></li>
      <li>содорегенерационные котлы;<a name="P0035"></a></li>
      <li>котлы-утилизаторы;<a name="P0037"></a></li>
      <li>котлы, используемые в передвижных и транспортабельных установках;<a name="P0039"></a></li>
    </ul>

    <h4>Дополнительные требования промышленной безопасности к котлам, работающим с органическими носителями, включают:</h4>

    <ol class="marked" style="margin-left: 14px;">
      <li>Обязательное предварительное согласование с изготовителем возможности применения теплоносителей, не указанных в паспорте используемого оборудования.</li>
      <li>Требования к установке бака для опорожнения системы (вне котельной).</li>
      <li>Обязательную установку двух предохранительных клапанов на каждом используемом котле.</li>
      <li>Обязательное оснащение котлов технологическими защитами, отключающими обогрев в ряде случаев, определенных в п.482 настоящих правил.</li>
      <li>А также требования к используемой арматуре, используемым расширительным сосудам, к месту установки котлов и др.</li>
    </ol>

    <h4>К дополнительным требованиям промышленной безопасности к применению содорегенерационных котлов относится:</h4>

    <ol class="marked" style="margin-left: 14px;">
      <li>Обеспечение мер по предупреждению высокотемпературной коррозии (при давлении более 4 МПа и температуре перегретого пара более 440&deg;С).</li>
      <li>Обязательная организация системы контроля состояния металла и сварных соединений.</li>
      <li>А также соблюдение требований к размещению, системе охлаждения, использованию вспомогательного топлива эксплуатируемых котлов и др.</li>
    </ol>

    <h4>К эксплуатации газотрубных котлов дополнительные требования промышленной безопасности включают:</h4>

    <ol class="marked" style="margin-left: 14px;">
      <li>Использование автоматической защиты при превышении параметров, установленных производственными инструкциями.</li>
      <li>Перечень случаев, требующих обязательную остановку парового и водогрейного котлов.</li>
    </ol>
    <app-atomka-calc heading="Получить консультацию эксперта и последующий расчет стоимости технического освидетельствования"></app-atomka-calc>
    <app-reviews-block class="w-100"></app-reviews-block>
  </div>

</div>
<app-footer></app-footer>
